export default {
    close: "Close popup window",
}